import { render, staticRenderFns } from "./PesticidesCompanies.html?vue&type=template&id=53c5ad52&external"
import script from "./PesticidesCompanies.js?vue&type=script&lang=js&external"
export * from "./PesticidesCompanies.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports